import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import NavItemAnchor from './NavItemAnchor'
import { Logo, NavWrapper } from './style'

const Nav = ({ navItems, children, ...props }) => {
  const navigate = useNavigate()

  return (
    <NavWrapper { ...props }>
      <Icon
        onClick={ () => navigate('/') }
      >
        <Logo />
      </Icon>
      <ul>
        { navItems.map(navItem => (
          <NavItemAnchor
            button={ navItem.button }
            href={ navItem.href }
            key={ navItem.href }
            rel={ navItem.rel }
            target={ navItem.target }
          >
            {navItem.content}
          </NavItemAnchor>
        ),
        )}
      </ul>
      { children }
    </NavWrapper>
  )
}

const Icon = styled.div`
  cursor: pointer;
`

Nav.propTypes = {
  children: PropTypes.node,
  navItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired,
  })).isRequired,
}

Nav.defaultProps = {
  children: null,
}

export default Nav
